export enum RequestChannel {
  WEB = "WEB",
  MOBILE = "MOBILE",
  BRANCH = "BRANCH",
  CALL_CENTER = "CALL_CENTER",
}

export interface RequestType {
  id: string;
  key: string;
  title: string;
  description: string;
  channels: RequestChannel[];
  enabled: boolean;
}

export interface RequestFilters {
  search?: string;
  channel?: RequestChannel;
  country?: string;
  segment?: string;
}

export const SEGMENTS = [
  { code: "PP", label: "Personne Physique" },
  { code: "PM", label: "Personne Morale" },
];
export const REQUESTS: RequestType[] = [
  {
    id: "create-prospect",
    key: "create_prospect",
    title: "Créer un prospect",
    description:
      "Saisir la création d’un prospect et déclencher le flux associé.",
    channels: [
      RequestChannel.WEB,
      RequestChannel.MOBILE,
      RequestChannel.BRANCH,
      RequestChannel.CALL_CENTER,
    ],
    enabled: true,
  },
  {
    id: "create-account",
    key: "create_account",
    title: "Ouverture de compte",
    description: "Démarrer une ouverture de compte bancaire.",
    channels: [
      RequestChannel.WEB,
      RequestChannel.MOBILE,
      RequestChannel.BRANCH,
      RequestChannel.CALL_CENTER,
    ],
    enabled: false,
  },
  // {
  //   id: "onboarding",
  //   key: "onboarding",
  //   title: "Démarrer Onboarding (A2)",
  //   description: "Ouvrir un dossier d’onboarding A2 pour un client/prospect.",
  //   channels: [
  //     RequestChannel.WEB,
  //     RequestChannel.MOBILE,
  //     RequestChannel.BRANCH,
  //     RequestChannel.CALL_CENTER,
  //   ],
  //   enabled: true,
  // },
  {
    id: "regen-otp",
    key: "regen_otp",
    title: "Régénérer accès (OTP)",
    description:
      "Envoyer des instructions OTP pour réinitialisation mot de passe / reconnexion.",
    channels: [
      RequestChannel.WEB,
      RequestChannel.MOBILE,
      RequestChannel.BRANCH,
      RequestChannel.CALL_CENTER,
    ],
    enabled: false,
  },
  {
    id: "secure-upload-reminder",
    key: "secure_upload_reminder",
    title: "Relance upload sécurisé",
    description: "Envoyer une relance avec lien sécurisé pour dépôt de pièces.",
    channels: [
      RequestChannel.WEB,
      RequestChannel.MOBILE,
      RequestChannel.BRANCH,
      RequestChannel.CALL_CENTER,
    ],
    enabled: false,
  },
  {
    id: "id-replacement",
    key: "id_replacement",
    title: "Remplacement de pièce d’identité",
    description: "Remplacer une pièce d’identité expirée ou invalide.",
    channels: [
      RequestChannel.WEB,
      RequestChannel.MOBILE,
      RequestChannel.BRANCH,
      RequestChannel.CALL_CENTER,
    ],
    enabled: false,
  },
  {
    id: "address-change",
    key: "address_change",
    title: "Changement d’adresse",
    description: "Mettre à jour l’adresse et justificatifs associés.",
    channels: [
      RequestChannel.WEB,
      RequestChannel.MOBILE,
      RequestChannel.BRANCH,
      RequestChannel.CALL_CENTER,
    ],
    enabled: false,
  },
  {
    id: "four-eyes",
    key: "four_eyes",
    title: "4‑yeux documentaire",
    description: "Déclencher un contrôle à 4‑yeux sur un dossier documentaire.",
    channels: [
      RequestChannel.WEB,
      RequestChannel.MOBILE,
      RequestChannel.BRANCH,
      RequestChannel.CALL_CENTER,
    ],
    enabled: false,
  },
  {
    id: "rekcy",
    key: "rekcy",
    title: "Déclencher Re‑KYC",
    description: "Ouvrir une demande Re‑KYC selon la politique en vigueur.",
    channels: [
      RequestChannel.WEB,
      RequestChannel.MOBILE,
      RequestChannel.BRANCH,
      RequestChannel.CALL_CENTER,
    ],
    enabled: false,
  },
  {
    id: "export-kpi",
    key: "export_kpi",
    title: "Exporter KPI conformité",
    description:
      "Demande d’export KPIs (complétude, expirés, erreurs OCR, ré‑usage).",
    channels: [
      RequestChannel.WEB,
      RequestChannel.MOBILE,
      RequestChannel.BRANCH,
      RequestChannel.CALL_CENTER,
    ],
    enabled: false,
  },
  {
    id: "contact-update",
    key: "contact_update",
    title: "Modification coordonnées",
    description: "Mettre à jour les informations de contact du client.",
    channels: [
      RequestChannel.WEB,
      RequestChannel.MOBILE,
      RequestChannel.BRANCH,
      RequestChannel.CALL_CENTER,
    ],
    enabled: false,
  },
  {
    id: "account-closure",
    key: "account_closure",
    title: "Clôture de compte",
    description: "Clôturer un compte bancaire actif.",
    channels: [RequestChannel.BRANCH, RequestChannel.CALL_CENTER],
    enabled: false,
  },
  {
    id: "add-proxy",
    key: "add_proxy",
    title: "Ajouter une procuration (mandataire)",
    description:
      "Créer/ajouter une procuration pour un client (portée et limites).",
    channels: [
      RequestChannel.WEB,
      RequestChannel.MOBILE,
      RequestChannel.BRANCH,
      RequestChannel.CALL_CENTER,
    ],
    enabled: false,
  },
  {
    id: "pep-declaration",
    key: "pep_declaration",
    title: "Déclaration PEP",
    description: "Déclarer ou mettre à jour le statut PEP (client ou proche).",
    channels: [
      RequestChannel.WEB,
      RequestChannel.MOBILE,
      RequestChannel.BRANCH,
      RequestChannel.CALL_CENTER,
    ],
    enabled: false,
  },
  {
    id: "civil-status-change",
    key: "civil_status_change",
    title: "Changement d'état civil",
    description:
      "Déclarer un changement d'état civil avec pièces justificatives.",
    channels: [
      RequestChannel.WEB,
      RequestChannel.MOBILE,
      RequestChannel.BRANCH,
      RequestChannel.CALL_CENTER,
    ],
    enabled: false,
  },
  {
    id: "add-legal-representative",
    key: "add_legal_representative",
    title: "Ajout représentant légal",
    description: "Ajouter/désigner un représentant légal avec justificatifs.",
    channels: [
      RequestChannel.WEB,
      RequestChannel.MOBILE,
      RequestChannel.BRANCH,
      RequestChannel.CALL_CENTER,
    ],
    enabled: false,
  },
  {
    id: "income-employer-update",
    key: "income_employer_update",
    title: "Mise à jour revenu et employeur",
    description:
      "Mettre à jour la rémunération, l'employeur et le secteur d'activité.",
    channels: [
      RequestChannel.WEB,
      RequestChannel.MOBILE,
      RequestChannel.BRANCH,
      RequestChannel.CALL_CENTER,
    ],
    enabled: false,
  },
  {
    id: "family-situation-change",
    key: "family_situation_change",
    title: "Changement de situation familiale",
    description:
      "Mettre à jour le régime matrimonial, le conjoint et le nombre d'enfants.",
    channels: [
      RequestChannel.WEB,
      RequestChannel.MOBILE,
      RequestChannel.BRANCH,
      RequestChannel.CALL_CENTER,
    ],
    enabled: false,
  },
];
